import React, { Component } from "react";
import "./pScene11.css";
import MaxFooter from "../../Footer";

class PScene11 extends Component<> {
  componentDidMount() {}

  render() {
    return (
      <section className={"p-container"}>
        <MaxFooter
          id={"pscene11"}
          className="content accessibility-img"
          contactsPath={`./contact`}
        />
      </section>
    );
  }
}
export default PScene11;
